import React from 'react';
import { UnattemptedQuizSection } from '../components/dashboard';

const UnattemptedQuizzes: React.FC = () => {
  return (
    <div className="unattempted-quizzes-page min-vh-100" style={{ backgroundColor: '#f8f9ff', paddingTop: '80px' }}>
      <div className="container py-4">
        {/* Page Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h2 className="fw-bold mb-2">
                  <i className="fas fa-list-check me-2 text-primary"></i>
                  Available Quizzes
                </h2>
                <p className="text-muted mb-0">
                  Explore and start new quizzes to improve your knowledge
                </p>
              </div>
              <div>
                <button className="btn btn-outline-primary rounded-pill px-4 me-2">
                  <i className="fas fa-filter me-2"></i>
                  Filter
                </button>
                <button className="btn btn-outline-secondary rounded-pill px-4">
                  <i className="fas fa-sort me-2"></i>
                  Sort
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Unattempted Quiz Section */}
        <UnattemptedQuizSection />
      </div>
    </div>
  );
};

export default UnattemptedQuizzes;
